import { render, staticRenderFns } from "./AppSegment.vue?vue&type=template&id=0361e196&"
import script from "./AppSegment.vue?vue&type=script&lang=js&"
export * from "./AppSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports